import { render, staticRenderFns } from "./ApprovalSidebar.vue?vue&type=template&id=56fac3e3"
import script from "./ApprovalSidebar.vue?vue&type=script&lang=js"
export * from "./ApprovalSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports